import { IFilterDeshabilitarAccesoPersonalModel } from '../interfaces/accesos/IFilterDeshabilitarAccesoPersonalModel';

export class FilterDeshabilitarAccesoPersonalModel
  implements IFilterDeshabilitarAccesoPersonalModel
{
  nombreEmpleado: string;
  nroDocumento: string;
  codigoSolicitud: string;
  fechaInicioServicio?: Date;
  fechaFinServicio?: Date;
  nombreContratista: string;
  page: number;
  pageSize: number;
  idCompania: number;
  sedes: number[];

  constructor() {
    this.nombreEmpleado = '';
    this.nroDocumento = '';
    this.codigoSolicitud = '';
    // fechaInicioServicio?: Date;
    // fechaFinServicio?: Date;
    this.nombreContratista = '';
    this.page = 1;
    this.pageSize = 30;
    this.idCompania = 0;
    this.sedes = [];
  }
}
